<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "OutletComponent",
};
</script>

<style scoped></style>
